import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// dinamically create pages routes
import pagesRoutes from "../../routes/pages.jsx";

import bgImage from "../../assets/img/full-screen-image-3.jpg";
import HpmHeader from "../../components/Header/HpmHeader";

class Pages extends Component {
  getPageClass() {
    var pageClass = "";
    switch (this.props.location.pathname) {
      case "/login":
        pageClass = " login-page";
        break;
      case "/pages/register-page":
        pageClass = " register-page";
        break;
      case "/pages/lock-screen-page":
        pageClass = " lock-page";
        break;
      default:
        pageClass = "";
        break;
    }
    return pageClass;
  }
  componentWillMount() {
    if (document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  componentDidMount() {
    this.id = localStorage.getItem("user_report");
  }
  render() {
    return (
      <div>
        <HpmHeader />
        <div className="wrapper wrapper-full-page">
          <div
            className={"full-page" + this.getPageClass()}
            data-color="black"
            data-image={bgImage}
          >
            <div className="content">
              <Switch>
                {pagesRoutes.map((prop, key) => {
                  return (
                    <Route
                      exact
                      path={prop.path}
                      component={prop.component}
                      key={key}
                    />
                  );
                })}

                {this.id === null && <Redirect to="/login" />}
              </Switch>
            </div>
            <div
              className="full-page-background"
              style={{ backgroundImage: "url(" + bgImage + ")" }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Pages;



// WEBPACK FOOTER //
// ./src/layouts/Pages/Pages.jsx